import React, { useState } from 'react';
import { BoxIcon, DeleteRedIcon } from '../../assets/icons';
import { DISPLAY_TEXTS, POPUP_TYPE } from '../../constants';
import { useLoader } from '../../context/LoaderContext';
import { addPackageToDispatch } from '../../service';
import { popup } from '../../utils';

export const BlpTilesDispatch = ({ tile, dispatch_id, dispatch_status, setPreScannedPackages }) => {
  const { setLoading } = useLoader();
  const isMixedSKU = tile?.data?.is_mixed ?? tile?.data?.package_id?.is_mixed;
  const tileClass = isMixedSKU ? 'pink-shade' : 'blue-shade';
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  const removeTile = () => {
    setIsDeleteLoading(true);

    addPackageToDispatch({
      data: {
        dispatch_id: dispatch_id,
        package_name: tile.BLP,
        type: 'remove',
      },
    })
      .then((response) => {
        setIsDeleteLoading(false);

        if (response?.message?.includes('removed')) {
          // remove the tile locally from state
          setPreScannedPackages((prev) =>
            prev.filter((pkg) => pkg.BLP !== tile.BLP)
          );

          popup(POPUP_TYPE.SUCCESS, response.message);
        } else {
          popup(POPUP_TYPE.ERR, response?.message || 'Something went wrong');
        }

        setLoading(false);
      })
      .catch(() => {
        setIsDeleteLoading(false);
        setLoading(false);
      });
  };

  return (
    <div className="col-xl-2 col-lg-4 col-6 custom-col pt-2">
      <div className="w-100 h-100 bg-white tiles">
        <div className={`w-100 d-flex align-items-center justify-content-center ${tileClass}`}>
          <span className="id-info">
            {DISPLAY_TEXTS.BLP_TILES[0]}
            <span>{tile.BLP}</span>
          </span>
        </div>
        <div className="w-100 d-flex align-items-center justify-content-center main-content-box">
          <div className="img-box">
            <BoxIcon />
          </div>
          <div className="sku-number flex-column d-flex align-items-start justify-content-start">
            <h6 className="m-0">
              {DISPLAY_TEXTS.BLP_TILES[1]}
              <span>{tile.SKU}</span>
            </h6>
            <p className="m-0">
              {DISPLAY_TEXTS.BLP_TILES[2]} {tile.Batch}
            </p>
          </div>
          {dispatch_status === 'draft' && (
            <div className="delete-icon-dispatch">
              {isDeleteLoading ? (
                <span
                  className="spinner-border spinner-border-sm text-danger"
                  role="status"
                />
              ) : (
                <DeleteRedIcon onClick={removeTile} style={{ cursor: 'pointer' }} />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
